export default __webpack_public_path__ + "static/media/65.df205c14.png";